import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';

import { Col, Container, Row, Spacer, Button } from '@cleartrip/bento';

function SrpBanner({ filter, redirectionUrl, isVisible }) {
	const [bannerVisible, setBannerVisible] = useState(false);
	const ANIMATION_DELAY = bannerVisible ? 0 : 1;
	const isSharingEnabled = navigator.share
	// const ANIMATION_DELAY =  4;
	const animationVariant = {
		default: {
			height: 0,
			overflow: 'hidden',
			visibility: 'hidden',
			opacity: 0,
		},
		active: {
			height: 'auto',
			visibility: 'visible',
			opacity: 1,
		},
	};

	useEffect(() => {
		if (isVisible) {
			setTimeout(() => {
				setBannerVisible(true);
			}, ANIMATION_DELAY);
		} else {
			setBannerVisible(false);
		}
	}, [isVisible]);

	function goToSrp() {
		setTimeout(() => {
			window.open(redirectionUrl, '_blank');
		}, 0);
	}

	const onShare = () => {
		navigator.share({
			title: 'Travelsafe',
			text: 'TravelSafe Cleartrip\'s guide to safe air travel',
			url: window.location.href
		})
	}

	return (
		<motion.div
			initial='default'
			transition={{ delay: ANIMATION_DELAY, duration: 0.4, linear: 'linear' }}
			variants={animationVariant}
			animate={filter.isFilterApplied ? 'active' : 'default'}
			className='z-30 p-fixed b-0 l-0 r-0 elevation-lg'
		>
			<motion.div
				// initial='default'
				key={filter.from.code + filter.to.code}
				transition={{ delay: ANIMATION_DELAY + 2, duration: 0.7, ease: 'easeInOut' }}
				// variants={animationVariant}
				animate={
					filter.isFilterApplied && {
						color: ['#FFF', '#1A1A1A'],
						background: ['#36C', '#FFF'],
					}
				}
				className='py-5 py-3--xs '
			>
				<Container>
					<Row>
						<Col span={24}>
							<div className='flex flex-middle flex-between'>
								<div className='flex flex-middle'>
									<motion.svg
										animate={{ color: ['#FFF', '#FFF', '#46991A'] }}
										transition={{ delay: ANIMATION_DELAY + 2, duration: 0.5, linear: 'linear' }}
										height={40}
										width={40}
										viewBox='0 0 16 16'
										className='d-none--xs'
									>
										<path
											fill='currentColor'
											fill-rule='evenodd'
											d='M8,0 C12.411,0 16,3.589 16,8 C16,12.411 12.411,16 8,16 C3.589,16 0,12.411 0,8 C0,3.589 3.589,0 8,0 Z M11.1645628,5.10661891 L6.36249622,9.24577974 L4.43327524,7.03236135 L3.30255198,8.01799055 L5.72236808,10.7940268 L5.79411425,10.865991 C6.04327656,11.0843028 6.40840643,11.1123437 6.68777675,10.9357296 L6.77744719,10.8692586 L12.1439977,6.24271185 L11.1645628,5.10661891 Z'
										/>
									</motion.svg>
									{/* <motion.svg
										animate={{ color: ['#FFF', '#FFF', '#46991A'] }}
										transition={{ delay: ANIMATION_DELAY + 2, duration: 0.7, linear: 'linear' }}
										height={16}
										width={16}
										viewBox='0 0 16 16'
										className='d-none d-block--xs'
									>
										<path
											fill='currentColor'
											fill-rule='evenodd'
											d='M8,0 C12.411,0 16,3.589 16,8 C16,12.411 12.411,16 8,16 C3.589,16 0,12.411 0,8 C0,3.589 3.589,0 8,0 Z M11.1645628,5.10661891 L6.36249622,9.24577974 L4.43327524,7.03236135 L3.30255198,8.01799055 L5.72236808,10.7940268 L5.79411425,10.865991 C6.04327656,11.0843028 6.40840643,11.1123437 6.68777675,10.9357296 L6.77744719,10.8692586 L12.1439977,6.24271185 L11.1645628,5.10661891 Z'
										/>
									</motion.svg> */}

									<Spacer className='pr-6 pr-0--xs d-none--xs' />
									<p className='c-inherit lh-copy d-none d-block--xs fw-500 fs-3'>
										{filter.from.code} → {filter.to.code} route <br /> is now{' '}
										<motion.span
											initial={{ color: '#fff' }}
											transition={{ delay: ANIMATION_DELAY + 2, duration: 0.7, ease: 'easeInOut' }}
											animate={{ color: ['#fff', '#46991A'] }}
										>
											open
										</motion.span>
									</p>
									<p className='c-inherit d-none--xs fw-500 fs-6'>
										{filter.from.code} → {filter.to.code} route is now open
									</p>
								</div>
								<div className='flex flex-middle'>
									<Button onClick={goToSrp} className='px-8 d-none--xs' size='lg'>
										View flights
									</Button>
									{isSharingEnabled && (
										<motion.button
											transition={{ delay: ANIMATION_DELAY + 2, duration: 0.7, ease: 'easeInOut' }}
											animate={{ color: ['#fff', '#36c'], borderColor: ['#fff', '#36c'], backgroundColor: 'transparent' }}
											initial={{ color: '#fff', borderColor: '#fff', backgroundColor: 'transparent' }}
											className='h-8 py-1 br-4 fs-3 ba px-7 fw-600 d-none d-block--xs'
											onClick={onShare}
										>
											Share
										</motion.button>
									)}

									<Spacer className='pr-0 pr-3--xs' />
									<Button onClick={goToSrp} className='d-none d-block--xs' size='sm'>
										View flights
									</Button>
								</div>
							</div>
						</Col>
					</Row>
				</Container>
			</motion.div>
		</motion.div>
	);
}

export default SrpBanner;
